export default function HeroSection() {
  return (
    <section
      className="relative w-full min-h-screen flex items-center justify-start overflow-hidden"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/6c2da24f2c54600fa669c13c502cbd0a.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* 오버레이 */}
      <div className="absolute inset-0 bg-white/30"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-40 pb-24">
        <div className="max-w-2xl">
          <p className="text-base md:text-lg font-semibold text-yellow-600 mb-4 tracking-wide">
            대구 · 경북 지역 한정 무료 견적 서비스
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-10">
            대구싱크대 교체,{' '}
            <span className="whitespace-nowrap">3분이면</span>
            <br />
            무료 견적이 완성됩니다.
          </h1>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="/kitchendesignprice"
              className="inline-flex items-center justify-center px-8 py-4 bg-yellow-400 text-gray-900 font-bold text-base rounded-md hover:bg-yellow-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              무료 견적 <strong className="ml-1">신청하기</strong>
            </a>
            <a
              href="https://blog.naver.com/hanskid"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-yellow-300 text-gray-900 font-bold text-base rounded-md hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer border border-yellow-400"
            >
              <i className="ri-article-line text-lg"></i>
              블로그 바로가기
            </a>
          </div>

          <p className="mt-6 text-sm text-gray-600 font-medium">
            * 대구 / 경북 지역 한정 무료 견적 진행 중 *
          </p>
        </div>
      </div>
    </section>
  );
}
